/**
 * Logger utility to replace console.log statements
 * This allows us to:
 * - Control logging based on environment
 * - Format logs consistently
 * - Add additional metadata if needed
 */

const ENABLE_LOGS = process.env.REACT_APP_ENABLE_LOGS !== 'false';
const isDevelopment = process.env.NODE_ENV === 'development';
const ENABLE_DEBUG = process.env.REACT_APP_DEBUG_LOGS === 'true';

const logger = {
  log: (...args) => {
    if (ENABLE_LOGS) {
      console.log(...args);
    }
  },

  info: (...args) => {
    if (ENABLE_LOGS) {
      console.info(...args);
    }
  },

  warn: (...args) => {
    if (ENABLE_LOGS) {
      console.warn(...args);
    }
  },

  error: (...args) => {
    if (ENABLE_LOGS) {
      console.error(...args);
    }
  },

  debug: (...args) => {
    if ((isDevelopment || ENABLE_DEBUG) && ENABLE_LOGS) {
      console.debug(...args);
    }
  },

  // Expose console for fallback/debugging
  console
};

export default logger;
